<template>
  <div>
    <span
      class="pointer"
      v-for="(route, index) in routeBack"
      v-bind:key="index"
      v-bind:class="{'backBar': (index - (routeBack.length -1) < 0)}"
      v-on:click="goBack(route, index)">
      <span v-if="routeBack.length > 1">/ </span>{{ route.toUpperCase() }}
    </span>
    <hr>
    <div class="alert alert-warning" v-if="!$online">
      <span>
        <center>
            <v-icon size="25">error</v-icon>
            <b>Bitte stellen Sie eine Internetverbindung her!</b>
            <v-icon size="25">error</v-icon>
        </center>
      </span>
    </div>
    <div class="card">
      <v-progress-linear v-if="loading" color="red" :indeterminate="true"></v-progress-linear>
      <div class="card-header text-xs-inline" id="graphheader">
        <h4 class="card-title">
          {{ title }} {{ subtitle }}
          <v-btn
            flat
            icon
            color="grey"
            id="graphbutton"
            title="Neuen Eintrag erstellen"
            v-on:click="addLog"
          >
            <v-icon size="50">add_circle</v-icon>
          </v-btn>
        </h4>
        <p class="card-category tablecard" id="subtitle"></p>
        <v-form>
          <v-container class="auswahl">
            <v-layout align-center wrap>
              <v-flex shrink pa-2>
                <label for="startdate">Startdatum:&nbsp;</label>
                <input type="date" id="date" v-model="startdate" />
                &nbsp;&nbsp;&nbsp;
                <label for="enddate">Enddatum:&nbsp;</label>
                <input type="date" id="date" v-model="enddate" />
              </v-flex>
              <v-flex pa-2>
                <v-btn color="grey" v-on:click="fetchData(startdate, enddate)">anzeigen</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </div>
    </div>
    <div class="table-responsive" v-if="!loading">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Lieferdatum</th>
            <th>Artikelgruppe</th>
            <th>Lieferant</th>
            <th>Temperatur (eingehalten)</th>
            <th>Name</th>
            <th>Bemerkung</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tempLog in tempLogs" v-bind:key="tempLog.id">
            <td>{{ transformDate(tempLog.datum) }}</td>
            <!-- <td>{{ tempLog.artikelkategorie }}</td> -->
            <td>
              <span v-for="(kategorie, index) of tempLog.artikelkategorie" :key="kategorie.value">
                {{ kategorie.name }}<span v-if="tempLog.artikelkategorie.length > 0 && index !== (tempLog.artikelkategorie.length - 1)">,</span>
                </span>
            </td>
            <td>{{ tempLog.lieferant }}</td>
            <td>{{ tempLog.temperatur }}°C 
              <span v-if="tempLog.eingehalten === 1">(<v-icon color="green" small>done</v-icon>)</span>
              <span v-if="tempLog.eingehalten === 0">(<v-icon color="red" small>close</v-icon>)</span>
            </td>
            <td>{{ tempLog.name }}</td>
            <td>{{ tempLog.bemerkung }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import navigation from '../../../../store/navigation';

export default {
  data() {
    return {
      startup: 1,
      routeBack: [],
      title: "Wareneingang - ",
      subtitle: "Temperaturkontrolle",
      startdate: "",
      enddate: "",
      auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
      tempLogs: [],
      loading: false
    };
  },
  methods: {
    goBack(route) {
      if (route !== "wareneingang") {
        this.$router.push({path: navigation.createNav(route).path});
      }
    },
    disableNotification(){
      this.showAlarm = false;
      this.showSuccess = false;
    },
    addLog() {
      this.$router.push({ path: "temperatur/add"});
    },
    transformDate(date) {
      var today = new Date(date);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      var newdate = dd + "." + mm + "." + yyyy;
      return newdate;
    },
    transformTime(time) {
      var tranformedTime = time.substring(0, 5);
      return tranformedTime;
    },
    startupFetch() {
      this.loading = true;
      var today = new Date();
      today.setDate(today.getDate() - 2);
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();

      var startdate = yyyy + "-" + mm + "-" + dd;
      this.startdate = startdate;

      var weekAgo = new Date();
      var dd1 = String(weekAgo.getDate()).padStart(2, "0");
      var mm1 = String(weekAgo.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy1 = weekAgo.getFullYear();
      var enddate = yyyy1 + "-" + mm1 + "-" + dd1;
      this.enddate = enddate;
      this.fetchData(startdate, enddate);
    },
    fetchData(start, end) {
      if (start > end) {
        this.checkDate = true;
      } else {
      console.log("abrufen der Logs aus der DB");
      this.$http
        .get(
          process.env.VUE_APP_NODE_API_URL +
            "/heimspiel/qs/wareneingang/temperatur/" +
            start +
            "&" +
            end,
          { headers: { Authorization: this.auth } }
        )
        .then(function (response) {
          // console.log(response);
          // wenn nicht der StartupFetch, dann vorher Logs löschen
          if (this.startup === 0) {
            this.tempLogs = [];
          }
          this.tempLogs = response.body.data;
          this.tempLogs.map(tempLog => {
            tempLog.artikelkategorie = JSON.parse(tempLog.artikelkategorie).map(kategorie => {
              if (kategorie === 1) {
                return kategorie = { value: 1, name: "Geflügel" };
              } else if (kategorie === 2) {
                return kategorie = { value: 2, name: "Rind" };
              } else if (kategorie === 3) {
                return kategorie = { value: 3, name: "Lamm" };
              } else if (kategorie === 4) {
                return kategorie = { value: 4, name: "Schwein" };
              } else if (![1, 2, 3, 4].include(kategorie)) {
                return kategorie = { value: 5, name: "Kategorie anlegen" };
              }
            });

            if (tempLog.lieferant === 1) {
              tempLog.lieferant = 'REWE';
            } else if (tempLog.lieferant === 2) {
              tempLog.lieferant = 'Nagel';
            } else if (tempLog.lieferant === 3) {
              tempLog.lieferant = 'Vita Beef';
            } else if (tempLog.lieferant === 4) {
              tempLog.lieferant = 'Niegemann';
            }
          });
          // statup = 0 damit die Logs geleert werden wenn neue abgerufen werden
          this.startup = 0;
          this.loading = false;
        });
      }
    },
  },
  created: function () {
    this.routeBack = navigation.createNav('wareneingang').params;
    this.startupFetch();
  },
  mounted() {

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#frame {
  margin-left: 0%;
  margin-top: 0%;
  padding-left: 0%;
  padding-top: 0%;
  padding-right: 0%;
}
.unterschriftTD {
  padding: 0%;
}
#date {
  margin-bottom: 10px;
  padding: 5px;
  border: 2px solid rgb(117, 108, 108);
  border-radius: 5px;
}
.auswahl {
  padding: 3px 3px 10px 3px !important;
}
.backBar:hover {
  cursor: pointer;
  text-decoration: underline;
  color: red;
}
.pointer {
  cursor: default;
}

</style>

